import { FC, useCallback, useState, useEffect, useRef } from 'react';

import imageList from 'data/imageList.json';

// function component
type Props = {
  doComplete: () => void;
};
/**
 * 画像プリロード
 * @description 画像を先行読込して、完了のフラグを返す
 * @param {Function} doComplete 完了時に実行する処理
 */
export const Image: FC<Props> = (props: Props) => {
  const { doComplete } = props;
  const [complete, setComplete] = useState<string[]>([]);

  const setTypeImageList = imageList as { [key: string]: string[] };

  const fileCount = useRef<number>(imageList.components.length + imageList.images.length);
  // console.log({ fileCount });

  const template = useCallback((dir: string, file: string, index: number) => {
    const result =
      dir === 'components' ? (
        <link
          key={index}
          rel="preload"
          href={require(`components/${file}`)}
          as="image"
          onLoad={() => {
            // console.log(file);
            setComplete(pre => [...pre, file]);
          }}
          onError={() => {
            console.error(file);
            setComplete(pre => [...pre, file]);
          }}
        />
      ) : (
        <link
          key={index}
          rel="preload"
          href={require(`images/${file}`)}
          as="image"
          onLoad={() => {
            // console.log(file);
            setComplete(pre => [...pre, file]);
          }}
          onError={() => {
            console.error(file);
            setComplete(pre => [...pre, file]);
          }}
        />
      );
    return result;
  }, []);

  // すべての画像を読み込み終わったら完了処理を実行
  useEffect(() => {
    // console.log(complete.length + ' / ' + fileCount.current);
    // console.log({ complete, setTypeImageList });
    // console.log('complete.length:', complete.length);
    // console.log('fileCount.current:', fileCount.current);
    if (complete.length === fileCount.current) {
      console.log('All images loaded');
      doComplete();
    }
  }, [complete, complete.length, doComplete, fileCount, setTypeImageList]);

  return (
    <>
      {imageList.components.map((img: string, index: number) => template('components', img, index))}
      {imageList.images.map((img: string, index: number) => template('images', img, index))}
    </>
  );
};
